import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "@/components/layout/AdminSidebar";
import AppTopbar from "@/components/layout/AppTopbar";
import LoadingScreen from "@/components/LoadingScreen";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import IdleTimer from "@/pages/auth/IdleTimer";

const TITLES = {
  "/admin/dashboard": ["Admin Dashboard", "Business & operations overview"],
  "/admin/users": ["User Management", "Manage platform users"],
  "/admin/jobs": ["Job Management", "All jobs across the platform"],
  "/admin/workstation": ["Technical Workstation", "Review, assign and process jobs"],
  "/admin/plans": ["Plans", "Manage credit plans and pricing"],
  "/admin/modules": ["Modules", "Analysis modules configuration"],
  "/admin/credit-ledger": ["Credit Ledger", "Global credit transactions"],
  "/admin/reports": ["Reports", "Revenue, jobs & user analytics"],
  "/admin/cms": ["Content Management", "Edit marketing website content"],
  "/admin/messages": ["Contact Messages", "Enquiries from the public site"],
  "/admin/audit": ["Audit Logs", "Sensitive admin activity"],
  "/admin/settings": ["Settings", "Admin account preferences"],
};

const ADMIN_ROLES = ["super_admin", "business_admin", "analyst_admin"];

export default function AdminLayout() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace state={{ from: pathname }} />;
  if (!ADMIN_ROLES.includes(user.role)) return <Navigate to="/app/dashboard" replace />;

  const [title, subtitle] =
    Object.entries(TITLES).find(([k]) => pathname.startsWith(k))?.[1] ||
    ["Admin", ""];

  return (
    <div className="min-h-screen bg-[#F8FAF7]">
      <IdleTimer />
      <AdminSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="lg:ml-64 min-h-screen flex flex-col">

        <AppTopbar
          title={title}
          subtitle={subtitle}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
